module.exports = __webpack_public_path__ + "static-v-shop/1792141392954/img/landing-mobile-logo.2f4da3d4.png";